module.exports = __webpack_public_path__ + "img/scitum-telmex.9503f952.png";